/* eslint-disable react/no-danger */
import classNames from 'classnames';
import React from 'react';

import { useImageUrl } from '../../hooks/useImage';

import ConsentButton from '../buttons/Consent';
import PageTitle from './PageTitle';

import styles from '../../../styles/partials/page-header.module.css';

interface PageHeaderProps {
    handle?: string | null;
    href?: string | null;
    title?: string | null;
    description?: string | null;
    right?: React.ReactNode;
    big?: boolean;
    icon?: React.ReactNode;
    image?: Image | null;
    isPageHeading?: boolean;
    children?: React.ReactNode;
    className?: string | null;
    innerClassName?: string | null;
    titleClassName?: string | null;
    textClassName?: string | null;
    colLeftClassName?: string | null;
    colRightClassName?: string | null;
}

function PageHeader({
    handle = null,
    href = null,
    title = null,
    description = null,
    right = null,
    big = false,
    icon = null,
    image = null,
    isPageHeading = true,
    children = null,
    className = null,
    innerClassName = null,
    titleClassName = null,
    textClassName = null,
    colLeftClassName = null,
    colRightClassName = null,
}: PageHeaderProps) {
    const imageUrl = useImageUrl(image);

    const titleElement = (
        <>
            <PageTitle
                title={title}
                icon={icon}
                href={href}
                isPageHeading={isPageHeading}
                className={classNames([styles.title, titleClassName])}
                textClassName={textClassName}
            />
            {description !== null || imageUrl !== null ? (
                <div
                    className={classNames([
                        styles.middle,
                        { [styles.hasImage]: imageUrl !== null },
                    ])}
                >
                    {description !== null ? (
                        <div
                            className={styles.description}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    ) : null}
                    {imageUrl !== null ? (
                        <img className={styles.image} src={imageUrl} alt={title || ''} />
                    ) : null}
                </div>
            ) : null}
            {handle === 'legal' ? (
                <div className={styles.consent}>
                    <ConsentButton />
                </div>
            ) : null}
        </>
    );

    // console.log('imageUrl', imageUrl, image);

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.big]: big,
                [className]: className !== null,
            })}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [innerClassName]: innerClassName !== null,
                    },
                ])}
            >
                {right !== null ? (
                    <div className={classNames(['container-responsive-cols', styles.cols])}>
                        <div
                            className={classNames([
                                'container-responsive-col',
                                styles.col,
                                styles.colLeft,
                                {
                                    [colLeftClassName]: colLeftClassName !== null,
                                },
                            ])}
                        >
                            {titleElement}
                        </div>
                        <div
                            className={classNames([
                                'container-responsive-col',
                                styles.col,
                                styles.colRight,
                                {
                                    [colRightClassName]: colRightClassName !== null,
                                },
                            ])}
                        >
                            {right}
                        </div>
                    </div>
                ) : (
                    titleElement
                )}
            </div>
            {children}
        </div>
    );
}

export default PageHeader;
